import Vue from 'vue';

export function sendForm(form, infoForm, recaptchaToken, dropzoneFiles) {
    infoForm.disabledForm = true;
    let fd = new FormData();
    fd.append('recaptchaToken', recaptchaToken);

    for (let i = 0; i < form.length; i++) {
        if (form[i].type === 'dropzone') {
            for (let j = 0; j < dropzoneFiles.length; j++) {
                fd.append(form[i].name, dropzoneFiles[j]);
            }

        } else if (form[i].type === 'select') {
            for (let k = 0; k < form[i].value.length; k++) {
                fd.append(form[i].name, form[i].value[k].id);
            }

        } else {
            fd.append(form[i].name, form[i].value.toString().trimEnd());
        }
    }

    if (infoForm.file && infoForm.file.is) {
        fd.append(infoForm.file.name, infoForm.file.value);
    }

    // для формы добавления коммента на странице блога
    if (infoForm.blogIdCmp) {
        fd.append('blogId', infoForm.blogIdCmp);
    }

    // если есть доп галочка в форме
    if (infoForm.addCheck && infoForm.addCheck.visible) {
        fd.append('postPhoto', infoForm.addCheck.is);
    }

    Vue.http.post(infoForm.action, fd)
        .then(response => response.json())
        .then(data => {
            infoForm.disabledForm = false;
            if (data.success) {
                infoForm.success = true;
                setTimeout(() => {
                    clearFrom(form, infoForm);
                }, 5000)
            } else {
                infoForm.error = true;
                setTimeout(() => {
                    infoForm.error = false;
                }, 5000)
            }
        })
        .catch(error => {
            infoForm.disabledForm = false;
            infoForm.error = true;
            setTimeout(() => {
                infoForm.error = false;
            }, 5000)
        });
}
export function validate(form, infoForm, route) {
    let is_valid = true;

    for (let i = 0; i < form.length; i++) {
        form[i].error = false;
        if (form[i].pattern !== '' && (!form[i].required ? form[i].value !== '' : true)) {
            form[i].valid = true;
            if (!form[i].pattern.test(form[i].value.trimEnd())) {
                form[i].error = true;
                form[i].valid = false;
                is_valid = false;
            }
        }
        if (form[i].required && form[i].value === '') {
            form[i].error = true;
            form[i].valid = false;
            is_valid = false;
        }

        if (
            form[i].type === 'select' &&
            form[i].required &&
            form[i].value.length === 0
        ) {
            form[i].error = true;
            form[i].valid = false;
            is_valid = false;
        } else if (form[i].type === 'select' &&
            form[i].required
        ) {
            form[i].valid = true;
        }
    }

    // проверка галочки
    if (!route.fullPath.includes('/lk') && !infoForm.isPersonalData) {
        infoForm.errorPersonalData = true;
        is_valid = false;
    }

    return is_valid;
}

export function changePersonalDataFrom(infoForm) {
    infoForm.isPersonalData = !infoForm.isPersonalData;
    infoForm.errorPersonalData = !infoForm.isPersonalData;
}

export function focusForm(form, i) {
    form[i].error = false;
}

export function clearFrom(form, infoForm) {
    infoForm.success = false;
    infoForm.error = false;
    for (let i = 0; i < form.length; i++) {
        form[i].error = false;
        form[i].valid = false;
        if (form[i].type === 'select') {
            form[i].value = [];
        } else {
            form[i].value = '';
        }
    }
    infoForm.isPersonalData = false;
    infoForm.errorPersonalData = false;

    document.querySelectorAll('[id^="personal-data"]').forEach(item => {
        item.checked = false;
    });

    if (infoForm.file && infoForm.file.is) {
        infoForm.file.label = staticText.forms.file;
        infoForm.file.error = false;
        infoForm.file.valid = false;
        infoForm.file.value = '';
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/formObjects.js